import { store } from '@redux/store';
import modalService from 'layout/services/modalService';
import circularProgress from '@icons/animations/circular-progress.json';
import { closeModalSvg } from '../constants/svgIcons';

export default class ThankScreenBrochure {
  constructor() {
    const state = store.getState();
    const modalInformation = state?.uiState?.modalInformation;
    const listingInformation = modalInformation?.listingInformation;

    this.url = modalInformation?.url;
    this.schedulerUrl = listingInformation?.schedulerUrl;
    this.hasCallTracking = listingInformation?.hasCallTracking === "True";
    this.phoneNumber = listingInformation?.phoneNumber;
    this.builderName = listingInformation?.brandName ?? 'the builder';
    this.marketId = listingInformation?.marketId;
    this.closeAttribute = '[data-close]';
    this.closeBtnId = 'closeBtn';
  }

 /**
 * Initializes the Lottie animation for the download animation container.
 * @function initializeAnimation
 * @memberof ThankScreenBrochure
 * @instance
 */
  static initializeAnimation() {
    import('lottie-web').then((lottie) => {
      lottie.loadAnimation({
        container: document.querySelector('#download-animation-container'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: circularProgress,
      });
    });
  }

  /**
   * Binds events to the ThankScreenBrochure component.
   * @function bindEvents
   * @memberof ThankScreenBrochure
   * @instance
   */
  bindEvents() {
    const closeElements = document.querySelectorAll(this.closeAttribute);
    closeElements.forEach((element) => element.addEventListener('click', ThankScreenBrochure.closeModal));

    const closeBtn = this.getCloseBtn();
    closeBtn?.addEventListener('click', ()=> document.body.dispatchEvent(new CustomEvent('closeAnchorClick')));
    
    ThankScreenBrochure.initializeAnimation();
  }

  /**
   * Closes the modal by clearing its HTML content.
   */
  static closeModal() {
    modalService?.clearHtml();
  }

   /**
   * Gets the close button element by ID.
   * @returns {HTMLElement} The button element.
   */
   getCloseBtn() {
    return document.getElementById(this.closeBtnId);
  }

  getHtml() {
    return `
    <div class="lead-form form--thanks">
      <button id="${this.closeBtnId}" class="modal__close" data-close>
        ${closeModalSvg}          
      </button>
      <div data-brochure-download-status class="brochure-download">
        <div class="brochure-download__spin-icon">
          <div id="download-animation-container"></div>
        </div>
        <p data-qa="thankyou-title" class="brochure-download__header">We're preparing your brochure</p>
        <p data-qa="thankyou-text" class="brochure-download__text">You're now connected with ${this.builderName}. We'll send you more info soon.</p>
        <p data-qa="thankyou-text" class="brochure-download__text">The brochure will download automatically when ready.</p>
      </div>

      <div data-brochure-download-status-completed class="brochure-download brochure-download-success" hidden>
        <p data-qa="thankyou-title" class="brochure-download__header">Brochure downloaded successfully</p>
        <p data-qa="thankyou-text" class="brochure-download__text">Your brochure has been saved. You're now connected with ${this.builderName}, and we've emailed you a copy for your convenience.</p>
        <p data-qa="thankyou-text" class="brochure-download__text">The brochure will download automatically when ready.</p>
      </div>
      
      <div class="form__button-bar thanks__button-bar">
        <button data-download-pdf-brochure class="brochure-download__btn-ok" data-close>Okay</button>      
      </div>
    </div>`;
  }
}
